module.exports = __webpack_public_path__ + "img/error.81cd68a4.png";